import styled from 'styled-components';

import { colorPrimary50 } from '@/styleUtils';

export const Option = styled.label`
  display: block;

  &:hover,
  &.focus-visible {
    background-color: ${colorPrimary50};
  }
`;

export default Option;
